'use client';

import Link from 'next/link';
import { ArrowRight } from 'lucide-react';
import { Button } from '@/components/ui/button';
import { trackCtaClicked } from '@/lib/posthog';

/**
 * Hero CTAs for the landing page. Isolated into a client component so we can
 * fire `cta_clicked` events without converting the entire marketing page into
 * a client tree.
 */
export function LandingHeroCTAs() {
  return (
    <div className="flex flex-col sm:flex-row gap-4 justify-center items-center mb-4">
      <Button asChild size="lg" className="btn-gradient-primary group">
        <Link
          href="/login"
          className="flex items-center gap-2"
          onClick={() =>
            trackCtaClicked({
              location: 'hero',
              destination: '/login',
              page: 'landing',
              label: 'Start Free Trial — No Card Required',
            })
          }
        >
          Start Free Trial — No Card Required
          <ArrowRight className="h-4 w-4 group-hover:translate-x-1 transition-transform" />
        </Link>
      </Button>
      <Button
        asChild
        variant="outline"
        size="lg"
        className="backdrop-blur-sm border-2 transition-all duration-300"
      >
        <Link
          href="/features#scoring"
          onClick={() =>
            trackCtaClicked({
              location: 'hero_secondary',
              destination: '/features#scoring',
              page: 'landing',
              label: 'See how scoring works',
            })
          }
        >
          See how scoring works
        </Link>
      </Button>
    </div>
  );
}
